export default __webpack_public_path__ + "static/media/charteDesDonneesPersonnelles.aafd83bd.pdf";